import './winmock4/style';
import FormStructure from './winmock4/form_structure';

export default FormStructure;